import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { jwtDecode } from "jwt-decode";

export default function ProtectedRoute({ Component, requiredRole }) {
  const { userSession } = useAuth();
  /* alert(
    "protectedRoute role: " + userSession.role + "token: " + userSession.token
  ); */

  // Ako korisnik nije prijavljen, preusmjeri ga na login
  if (!userSession || !userSession.token) {
    return <Navigate to="/login" replace />;
  }

  try {
    const decodedToken = jwtDecode(userSession.token);
    const userRole = decodedToken.role; // Provjera role iz tokena
    //console.log("protectedRoute role: ", userRole);

    // Ako korisnik nema odgovarajuću rolu, preusmjeri ga na unauthorized stranicu
    if (userRole !== requiredRole) {
      return <Navigate to="/" replace />;
    }
  } catch (error) {
    console.error("Invalid token:", error);
    return <Navigate to="/login" replace />;
  }

  return <Component />;
}
